import { action, makeAutoObservable } from "mobx"
import {
    MenuCategory,
    MenuItem,
    MenuItemModifierSet,
} from "../../../../services/menu/models";

export enum MenuFormType {
    createMenuCategory = "createMenuCategory",
    deleteMenuCategory = "deleteMenuCategory",
    createMenuItem = "createMenuItem",
    copyMenuItem = "copyMenuItem",
    editMenuItem = "editMenuItem",
    deleteMenuItem = "deleteMenuItem",
    editMenuModifiersSet = 'editMenuModifiersSet',
    deleteMenuModifiersSet = 'deleteMenuModifiersSet',
    editCategoriesForm = 'editCategoriesForm',
    editItemsOrdersForm = 'editItemsOrdersForm',
}

export enum FormDisplayType {
    popup = "popup",
    inline = "inline"
}

class MenuFormsStore {
    forms: {
        [MenuFormType.createMenuCategory]: {
            current?: MenuCategory,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.deleteMenuCategory]:{
            current?: MenuCategory,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.createMenuItem]: {
            current?: MenuItem,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.editMenuItem]: {
            current?: MenuItem,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.copyMenuItem]: {
            current?: MenuItem,
            type: FormDisplayType.popup,
            open: boolean
        },
        [MenuFormType.deleteMenuItem]:{
            current?: MenuItem,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.editMenuModifiersSet]: {
            current?: MenuItemModifierSet,
            type: FormDisplayType,
            open: boolean,
            init: {name?: string},
            notifyOnDone?: (modifierSetId: number) => void;
        },
        [MenuFormType.deleteMenuModifiersSet]: {
            current?: MenuItemModifierSet,
            type: FormDisplayType,
            open: boolean,
        },
        [MenuFormType.editCategoriesForm]:{
            current?: MenuCategory[],
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.editItemsOrdersForm]:{
            current?: MenuCategory,
            type: FormDisplayType,
            open: boolean
        },

    } = {

        [MenuFormType.createMenuCategory]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.deleteMenuCategory]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.createMenuItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.copyMenuItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.editMenuItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.deleteMenuItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.editMenuModifiersSet]: {
            type: FormDisplayType.popup,
            open: false,
            init:{}
        },
        [MenuFormType.deleteMenuModifiersSet]: {
            type: FormDisplayType.popup,
            open: false,
        },
        [MenuFormType.editCategoriesForm]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.editItemsOrdersForm]:{
            type: FormDisplayType.popup,
            open: false
        }
    };

    constructor() {
        makeAutoObservable(this);
    }

    @action
    showPopupForm(type: MenuFormType, current?: any) {
        this.forms[type].open = true;
        this.forms[type].current = current;
        this.forms[type].type = FormDisplayType.popup;
    }

    @action
    closeForm(type: MenuFormType) {
        this.forms[type].open = false;
        this.forms[type].current = undefined;
    }
    @action
    setModifiersSetInitDataAndNotify(
        params: Partial<{ name: string}>,
        notify: (modifierSetId: number) => void
    ) {
        this.forms[MenuFormType.editMenuModifiersSet].init = {
            name: params.name,
        };
        this.forms[MenuFormType.editMenuModifiersSet].notifyOnDone = notify;
    }
}

export default MenuFormsStore
